import { render, staticRenderFns } from "./CancelCourierPopup.vue?vue&type=template&id=4a2e1df2"
import script from "./CancelCourierPopup.vue?vue&type=script&lang=js"
export * from "./CancelCourierPopup.vue?vue&type=script&lang=js"
import style0 from "./CancelCourierPopup.vue?vue&type=style&index=0&id=4a2e1df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports